module.exports = __webpack_public_path__ + "assets/img/business-ecology-icon4.403f35b4.png";